<template>
  <b-row>
    <b-col>
      <b-card
        style="margin:0;border:1px solid #2980b9 ;padding:0 10px; cursor: pointer"
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          style="color: black; font:45px; padding: 0 1px"
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
        >
          <span class="lead collapse-title">
            <strong>MOTIVO DE CONSULTA </strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </b-card-header>
        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">

            <div>
              <label class="mt-2">Motivo de consulta</label>
              <b-form-textarea
                v-model="motivoConsulta"
                placeholder="Describa el motivo de la consulta..."
                rows="3"
                @input = "inputMotivoConsulta"
                no-resize
              />
            </div>

            <div class="my-2"> 
               
            </div>

            <b-form-group  class = "mt-1" >
              <b-button 
                @click = "copyAS400()" 
                variant = "info"
              >
                AS400  <i class="fas fa-copy"/>
              </b-button>
            </b-form-group>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import { mapState } from "vuex";
import { copyText } from "@/shared/helpers";

export default {

  name: "MotivoConsulta",

  components: {
  },

  data() {
    return {
      visibleBody:false,
      motivoConsulta : '',
    }
  },


  created() {
    this.loadDataLS();
  },


  methods: {

    loadDataLS(){
      const anamnesis      = JSON.parse(localStorage.getItem("crearAnamnesis"));
      const motivoConsulta = anamnesis?.motivoConsulta;
      this.motivoConsulta  = motivoConsulta;
    },
   
    onVisibleBody(value) {
      this.visibleBody = value;
    },

    copyAS400(){
      copyText(this.summaryText);
    },

    inputMotivoConsulta(){
      const { motivoConsulta } = this.motivoConsulta;
      this.$store.commit("setMotivoConsulta", motivoConsulta);
    }

  },

  watch: {
 
    motivoConsulta: {
      deep: true,
      handler(newValue) {
        if(newValue){
          this.$store.commit("setMotivoConsulta", newValue);
        }
      }
    },
  },

  computed: {
    ...mapState({
      stMotivoConsulta: state => state.atencionCita.anamnesis?.motivoConsulta,
    }),

    summaryText(){
      const text = this.motivoConsulta;
      return text;
    }
  },

}
</script>
